export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Extrator de Áudio",
  "Extract sound from videos with ease.": "Extrair som de vídeos com facilidade.",
  "Select Audio Format": "Selecionar o Formato de Áudio",
  "Extract Audio": "Extrair o Áudio",
  "Extracting Audio": "Extraindo o Áudio",
  "Extracted Successfully": "Extraído Com Sucesso",
  "Extract New": "Extrair Novo",
  "Extraction Failed": "Falha em Extrair",
  "Format": "Formato",
};
